module.exports = __webpack_public_path__ + "img/borderWavesBlue.1ad6aff0.svg";